import { useToggle } from "usehooks-ts";

import { SKSpinner } from "components/customElements/skSpinner";

export const TOOL_Alt_DATA_ANALYSIS_NAME = "Alt Data Analysis";
export const TOOL_Alt_DATA_ANALYSIS_DESCRIPTION =
  "Overlay Google search interest and Wikipedia pageviews on share price to surface signals across global equities";

const ToolAltDataAnalysisPage = () => {
  const [isLoading, toggleIsLoading] = useToggle(true);
  return (
    <div className="">
      {isLoading && (
        <div className="w-full flex justify-center">
          <SKSpinner />
        </div>
      )}
      <iframe
        src="https://altdata.smartkarma.com"
        onLoad={toggleIsLoading}
        onError={toggleIsLoading}
        frameBorder={0}
        className="w-full h-[600px] md:h-[100vh] border-0"
        allowFullScreen
        allow="clipboard-write"
      ></iframe>
    </div>
  );
};

export default ToolAltDataAnalysisPage;
